import { ProfileEditComponent } from '../profile-edit/profile-edit.component';
import { Component, OnInit, ViewChild, Input, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { ProfileMin } from '../shared/profile-min.model';
import { ProfileService } from '../shared/profile.service';
import { ProfileResultsGridComponent } from '../profile-results-grid/profile-results-grid.component';
import { ProfileQuicksearchComponent } from '../profile-quicksearch/profile-quicksearch.component';
import { NotificationService, TranslationService } from 'src/app/shared';
import { ObservationService } from 'src/app/shared/observation/observation.service';

@Component({
  selector: 'wl-profile-relate-existing',
  templateUrl: './profile-relate-existing.component.html',
  styleUrls: ['./profile-relate-existing.component.css'],
    standalone: false
})
export class ProfileRelateExistingComponent implements OnInit, OnChanges {
  @ViewChild(ProfileResultsGridComponent) private _resultsGrid: ProfileResultsGridComponent;
  @ViewChild(ProfileQuicksearchComponent) private _quicksearch: ProfileQuicksearchComponent;
  @ViewChild(ProfileEditComponent) private _editComponent: ProfileEditComponent;
  @Input() profileId: number;

  public profile: ProfileMin;
  public selectedProfile: ProfileMin;
  public showRelatedModal: boolean;

  constructor(
    private _profileService: ProfileService,
    private _notificationService: NotificationService,
    private _translationService: TranslationService,
    private _observationService: ObservationService
  ) {
    this.selectedProfile = new ProfileMin();
  }

  ngOnInit() {
    this.loadProfile();
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    if (simpleChanges.profileId) {
      this.loadProfile();
    }
  }

  public open() {
    this.showRelatedModal = true;
  }

  public close() {
    this.selectedProfile = new ProfileMin();
    this._quicksearch.reset();
    this.showRelatedModal = false;
  }

  public showResults(value) {
    this._resultsGrid.profileResults = value;
  }

  public selectProfile(value) {
    this.selectedProfile = value;
  }

  public save() {
    this._editComponent.saveClick(false).then((success: boolean) => {
      if (success) {
        this._notificationService.success(this._translationService.getInstant('profiles.relate-existing.success'));
        this._observationService.relationAdded(this.profileId);
        this.selectedProfile = new ProfileMin();
        this._quicksearch.reset();
        this.showRelatedModal = false;
      } else {
        this._notificationService.error(this._translationService.getInstant('profiles.relate-existing.failure'));
      }
    });
  }

  private loadProfile() {
    this._profileService.getProfileMin(this.profileId).then((data: ProfileMin) => {
      this.profile = data;
    });
  }
}
